import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';
import { EntityService } from 'src/app/_core/entity.service';
import { OrderItemsUtilsService } from 'src/app/order-items/order-items-util.service';

import * as _ from 'lodash';


@Injectable({
	providedIn: 'root'
})
export class OrderItemsProcessService {

	constructor(
		private appService: AppService,
		public entityService: EntityService,
		public orderUtils: OrderItemsUtilsService,

		public dialog: MatDialog,
	) {
	}

	async addItemsToOrder($storage, pending?) {
		let payload: any = this.getPreparedOrder($storage);
		let url = `/online-shopper/orders/${$storage.orderId}/order`;
		if (pending) {
			url += '?pending=1';
		}
		try {
			let response = await this.entityService.post(url, payload, { 'ros-organization': $storage.siteId });
			return response;
		} catch (err) {
			throw (err);
		}
	}

	getPreparedOrder(_storage) {
		let that = this;
		let ret = {
			orderedOffers: [],
			orderedItems: [],
			diner: {
				name: localStorage.getItem('c_name') || '?'
			}
		}
		_storage.basket.forEach(offer => { prepareOffer(offer) });
		return ret;


		function prepareOffer(offer) {
			let q = offer.quantity || 1;
			for (let i = 0; i < q; i++) {
				var parsedOffer: any = {
					"_id": that.orderUtils.getObjectId(),
					"amount": Math.round(offer.total * 100),
					"menu": offer.menu,
					"price": offer.openPrice ? 0 : Math.round(offer.price * 100),
					"offer": offer.offer,
					"name": offer.realName || offer.name,
					"upsellType": offer.upsaleType,
					"orderedItems": []
				}
				//if (complexDiners) parsedOffer.diner = offer.diner;

				// main offer item
				if (offer._item) {
					var pitem = prepareBasketOfferItem(offer._item, offer._item.total);
					if (pitem) {
						if (offer.isWeight) {
							pitem.uom = offer.uom;
							pitem.units = offer.baseUnits;
						}
						if (offer.openPrice) {
							pitem.amount = pitem.price = parsedOffer.amount;
						}
						//if (offerPromotion) pitem.onTheHouse = offerPromotion;
						ret.orderedItems.push(pitem);
						parsedOffer.orderedItems.push(pitem._id);
						//ret.courses[0].orderedItems.push(pitem._id);
					}
				}
				// basket items
				_.each(offer.selectionSummary, function (selectionGroup) {
					_.each(selectionGroup.items, function (item) {
						let count = item.count || 1
						for (let i = 0; i < count; i++) {
							var pitem = prepareBasketOfferItem(item._item, item.price, selectionGroup);
							if (pitem) {
								ret.orderedItems.push(pitem)
								parsedOffer.orderedItems.push(pitem._id);
								//ret.courses[0].orderedItems.push(pitem._id);
							}
						}
					});
				});
				ret.orderedOffers.push(_.cloneDeep(parsedOffer));
			}


			function prepareBasketOfferItem(item, itemPrice, group?) {
				isInInventory(item._id, item.name);

				if (!itemPrice) itemPrice = 0;
				var parsedItem: any = {
					"_id": that.orderUtils.getObjectId(),
					"category": item.category && item.category._id,
					"item": item._id,
					"name": item.realName || item.name,
					"price": Math.round(itemPrice * 100),
					"tags": item.tags || []
				}
				//if (complexDiners) parsedItem.diner = offer.diner;

				if (item.notes) {
					parsedItem.note = item.notes;
				}
				if (group) {
					parsedItem.itemGroup = item.itemGroup;
					parsedItem.itemGroupName = group.name;
				} else {
					parsedItem.offer = offer.offer;
					parsedItem.menu = offer.menu;
				}
				//if (note) parsedItem.note = note;
				var itemAmount = parsedItem.price || 0;
				var modifiers = [];
				var removedModifiers = [];

				_.each(item.modifierGroups, function (group) {
					if (group.singleSelection) {
						var mod: any = _.find(group.modifiers, { '_selected': true });
						if (mod) {
							modifiers.push(prepareBasketModifier(mod, group, false, true));
							if (!mod._isDefault) {
								var defMod = _.find(group.modifiers, { '_isDefault': true });
								if (defMod) removedModifiers.push(prepareBasketModifier(defMod, group, false, false));
							}
						}
					} else {
						var isGroupCheckbox = group.modifierBehavior == "checkbox";
						_.each(group.modifiers, function (mod) {
							if (mod.formationUnit) {
								let modCount = mod.count || 1;
								for (var i = 0; i < modCount; i++) {
									if (mod.price) itemAmount = itemAmount + Math.round(mod.price * 100);
									modifiers.push(prepareBasketModifier(mod, group, true, true));
								}
							} else if (mod.defaultFormationUnit) {
								removedModifiers.push(prepareBasketModifier(mod, group, false, false));
							}
						});
					}
				});
				parsedItem.selectedModifiers = modifiers;
				parsedItem.removedModifiers = removedModifiers;
				parsedItem.amount = Math.round(itemAmount);
				return parsedItem;
			}
		}

		function prepareBasketModifier(mod, group, checkSubMods, checkInventory?) {
			let itemId = (mod.item && mod.item._id) || mod.item;
			if (checkInventory) {
				isInInventory(itemId, mod.name);
			}

			var _mod: any = {
				"modifier": mod._id,
				"name": mod.realName || mod.name,
				"modifierGroup": group._id,
				"modifierGroupName": group.realName || group.name,
				"item": itemId,
				"price": 0,
				"amount": 0,
				"formationUnit": mod.formationUnit,
				"isDefault": mod._isDefault || mod.defaultFormationUnit != null
			};
			if (!isNaN(mod.price) && mod.price !== 0) {
				_mod.price = Math.round(mod.price * 100);
			}
			if (checkSubMods) {
				let selectedModifiers = [], removedModifiers = [];
				_.each(mod.groups, function (group) {
					selectedModifiers.push({
						"modifier": group.value,
						"name": group.valueName,
						"modifierGroup": group._id,
						"modifierGroupName": group.realName || group.name,
						"isDefault": group._default == group.value
					});
				});
				if (mod._item) {
					_.each(mod._item.modifierGroups, function (group) {
						if (group.singleSelection) {
							var mod: any = _.find(group.modifiers, { '_selected': true });
							if (mod) {
								selectedModifiers.push(prepareBasketModifier(mod, group, false, false));
								if (!mod._isDefault) {
									var defMod = _.find(group.modifiers, { '_isDefault': true });
									if (defMod) removedModifiers.push(prepareBasketModifier(defMod, group, false, false));
								}
							}
						} else {
							group.modifiers.forEach(mod => {
								if (mod.formationUnit) {
									selectedModifiers.push(prepareBasketModifier(mod, group, false, false));
								} else if (mod.defaultFormationUnit) {
									removedModifiers.push(prepareBasketModifier(mod, group, false, false));
								}
							});
						}
					});
				}

				if (selectedModifiers.length) {
					_mod.selectedModifiers = selectedModifiers;
				}
				if (removedModifiers.length) {
					_mod.removedModifiers = removedModifiers;
				}
			}
			return _mod;
		}

		function isInInventory(itemId, itemName) {
			//let inv = options.inventory[itemId];
			//if (inv) {
			//	if (inv.quantity == 0) {
			//		wasMissingInInventory = true;
			//		if (!missingItems[itemId]) {
			//			missingItems[itemId] = itemName;
			//		}
			//		return false;
			//	}
			//	inv.quantity = inv.quantity - 1;
			//}
			return true;
		}

	}


}
